// cabbages.ts
import debug from "debug";
var log = debug("cabbages");
function pojo(target) {
  return typeof target == "object" && typeof target != null && Object.getPrototypeOf(target) == Object.prototype;
}
var BLOCK_MARKER = "\uFFFC";
function apply(target, ...rest) {
  if (rest.length == 0) {
    log("empty patch");
    return;
  }
  const [path, range, val] = rest;
  let p = [...path];
  while (true) {
    let key = p.shift();
    if (!p.length) {
      const RANGE_ARRAY = Array.isArray(range);
      if (pojo(target) && RANGE_ARRAY && typeof key == "undefined" && typeof range[0] == "string") {
        delete target[range[0]];
        return;
      }
      if (RANGE_ARRAY || typeof range == "number") {
        if (typeof key == "undefined") {
          throw new Error("cant treat top level as a seq");
        }
        key = key;
        let [start, end] = Array.isArray(range) ? range : [range, range + 1];
        const ZERO_LENGTH = Array.isArray(range) && range.length == 0;
        if (!ZERO_LENGTH && (start == null || end == null)) {
          throw new RangeError("it's all or nothing, no half measures");
        }
        const DELETE = typeof val == "undefined";
        const INSERT = start === end && !DELETE;
        const APPEND = ZERO_LENGTH && !DELETE;
        const REPLACE = !INSERT && !DELETE && !APPEND;
        if (typeof target[key] == "undefined") {
          if (typeof target == "string") {
            return;
          } else if (typeof val == "string") {
            target[key] = "";
          } else {
            target[key] = [];
          }
        }
        let seq = target[key];
        if (Array.isArray(seq)) {
          if (APPEND) {
            Array.isArray(val) ? seq.push(...val) : seq.push(val);
            return;
          }
          if (INSERT || REPLACE) {
            Array.isArray(val) ? seq.splice(start, end - start, ...val) : seq.splice(start, end - start, val);
            return;
          }
          if (DELETE) {
            seq.splice(start, end - start);
            return;
          }
          throw new Error("i don't know what happened");
        }
        if (typeof seq == "string") {
          if (APPEND) {
            target[key] = seq + val;
            return;
          }
          if (REPLACE || INSERT) {
            target[key] = seq.slice(0, start) + (typeof val == "string" ? val : val.map(
              (n) => typeof n == "string" ? n : BLOCK_MARKER
            ).join("")) + seq.slice(end);
            return;
          }
          if (DELETE) {
            target[key] = seq.slice(0, start) + seq.slice(end);
            return;
          }
          throw new Error("i don't know what happened");
        }
        if (pojo(seq) && RANGE_ARRAY && typeof range[0] == "string") {
          delete seq[range[0]];
          return;
        }
        throw new Error("not implemented");
      }
      if (typeof key == "undefined") {
        if (typeof range != "string") {
          throw new Error(`can't index top-level map with ${range}`);
        }
        if (typeof val == "undefined") {
          delete target[range];
        } else {
          target[range] = val;
        }
        return;
      }
      if (typeof target[key] == "undefined") {
        target[key] = {};
      }
      if (RANGE_ARRAY) {
        let [a, b] = range;
        if (a != null && b != null) {
          if (typeof val == "undefined" && a != null && b != null) {
            delete target[key][a || b];
          } else {
            target[key][a || b] = val;
          }
        }
      } else {
        if (typeof val == "undefined") {
          delete target[key][range];
        } else if (typeof target[key] == "string") {
          return;
        } else {
          target[key][range] = val;
        }
      }
      return;
    }
    if (typeof key == "undefined") {
      throw new Error("cant treat top level as a seq");
    }
    key = key;
    let nextkey = p[0];
    if (typeof target[key] == "undefined") {
      if (typeof nextkey == "string") {
        target[key] = {};
      } else if (typeof nextkey == "number") {
        target[key] = [];
      } else {
        throw new Error(`can't go down this road ${target}.${key}.${nextkey}`);
      }
    }
    target = target[key];
  }
}
var patch = apply;
function get(obj, key) {
  for (let p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : void 0;
  }
  return obj;
}
function fromAutomerge(autopatch, payload) {
  const path = autopatch.path.slice(0, -1);
  const key = autopatch.path[autopatch.path.length - 1];
  switch (autopatch.action) {
    case "mark":
    case "unmark":
      log(
        `skipping ${autopatch.action} because it doesn't affect material reality`
      );
      return [];
    case "inc":
      if (payload) {
        return [path, key, get(payload.patchInfo.after, autopatch.path)];
      } else {
        throw new Error(
          `can't apply ${autopatch.action} without payload argument`
        );
      }
    case "conflict":
      if (payload) {
        return [path, key, get(payload.patchInfo.after, autopatch.path)];
      } else {
        throw new Error(
          `can't apply ${autopatch.action} without payload argument`
        );
      }
    case "del": {
      return typeof key == "string" ? [path, key] : [path, [key, key + (autopatch.length || 1)]];
    }
    case "insert": {
      return [path, [key, key], autopatch.values];
    }
    case "splice": {
      return [path, [key, key], [autopatch.value]];
    }
    case "put": {
      return [path, key, autopatch.value];
    }
  }
}
export {
  apply,
  fromAutomerge,
  patch,
  pojo
};
